import { render, staticRenderFns } from "./ParticipantCreate.vue?vue&type=template&id=60cdc207&scoped=true&"
import script from "./ParticipantCreate.vue?vue&type=script&lang=ts&"
export * from "./ParticipantCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cdc207",
  null
  
)

export default component.exports